type LoadingTableSkeletonProps = {
  rowCount: number;
  rowHeightPx: number;
};

/**
 * Plain full-width pulse skeleton rendered while `isColumnsReady` is false.
 *
 * Before `applyPresetColumnsAndSort` resolves the preset's column widths,
 * `columnStates` only carries default widths — rendering the real header and
 * column-aware skeleton would cause a visible width-jump flash. This skeleton
 * intentionally has no column structure so the transition is invisible.
 */
export function LoadingTableSkeleton(props: LoadingTableSkeletonProps) {
  return (
    <table className="w-full text-sm" style={{borderCollapse: 'separate', borderSpacing: 0}}>
      <tbody>
        {Array.from({length: props.rowCount}, (_, i) => (
          <tr key={i} style={{height: props.rowHeightPx}}>
            <td className="p-2">
              <div className="animate-pulse bg-gray-200 h-4 rounded" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
